// Detects whether a picked file is a playable video. Excludes the non-playable DLNA MPEG-TS type.
export const isFileVideo = (file: {type: string}) =>
  file.type.includes('video') && file.type !== 'video/vnd.dlna.mpeg-tts';
